//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class ResourceConstants
{
	public static supportedImageMimeTypes: string = `.jpg,.jpeg,.png`;
	public static imageFileSizeLimit: number = 30000000;
	public static audioFileSizeLimit: number = 30000000;
	public static videoFileSizeLimit: number = 100000000;
}
